import { pick } from 'lodash';
import { create as createStore } from 'zustand';
import { persist } from 'zustand/middleware';

import {
  createDocumentSigningSlice,
  DocumentSigningSlice,
} from './states/documentSigning';
import {
  createFilterSelectionSlice,
  type FilterSelectionSlice,
} from './states/filterSelection';
import { createResetSlice, type ResetSlice } from './states/reset';
import { createSessionSlice, type SessionSlice } from './states/session';
import {
  createTableGroupExpansionSlice,
  TableGroupExpansionsSlice,
} from './states/tableGroupExpansions';
import {
  createTablePaginationSlice,
  TablePaginationSlice,
} from './states/tablePagination';
import {
  createTableRowSelectionSlice,
  type TableRowSelectionSlice,
} from './states/tableRowSelection';
import {
  createTableSortColumnsSlice,
  TableSortColumnsSlice,
} from './states/tableSorting';
import { createUiSlice, type UiSlice } from './states/ui';
import {
  createWorkflowStateSelectionSlice,
  type WorkflowStateSelectionSlice,
} from './states/workflowStateSelection';

export type StateSlices = FilterSelectionSlice &
  ResetSlice &
  SessionSlice &
  UiSlice &
  WorkflowStateSelectionSlice &
  TableRowSelectionSlice &
  TableGroupExpansionsSlice &
  TablePaginationSlice &
  TableSortColumnsSlice &
  DocumentSigningSlice;

export const useStore = createStore<StateSlices>()(
  persist(
    (...a) => ({
      ...createFilterSelectionSlice(...a),
      ...createResetSlice(...a),
      ...createSessionSlice(...a),
      ...createUiSlice(...a),
      ...createWorkflowStateSelectionSlice(...a),
      ...createTableRowSelectionSlice(...a),
      ...createTableGroupExpansionSlice(...a),
      ...createTablePaginationSlice(...a),
      ...createTableSortColumnsSlice(...a),
      ...createDocumentSigningSlice(...a),
    }),
    {
      name: 'portal-next-state',
      partialize: (state) =>
        pick(
          state,
          'isNavigationCollapsed',
          'isPageSidebarPinned',
          'pageSidebarWidth'
        ),
      version: 1,
    }
  )
);
